import { Button, ButtonProps } from '../button'

const FormBlockSubmitButton = (props: ButtonProps) => {
    return (
        <div className="mb-4 grid grid-cols-3 gap-4">
            <div />

            <div className="col-span-2 text-right">
                <Button {...props} />
            </div>
        </div>
    )
}

export default FormBlockSubmitButton
